module.exports = __webpack_public_path__ + "img/iam_icon.ca6edb46.png";